<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:00em;">This book is dedicated to Jenneke Kelly, my cousin, who sadly lost her life from pancreatic cancer in July 2022 at the age of 52. She was an avid reader and had recently qualified as a funeral celebrant. The character, named after her, is loosely based on her and she was delighted to be memorialised in this book.</p><br/>
<p style="text-indent:00em;">‘Your inclusion of me as a funeral celebrant in your forthcoming murder mystery novel is splendid. Thank you for thinking of placing me in this role, I’m truly honoured and the prospect of longevity through fiction is highly appealing.’ – Jenneke, Tuesday, 17 May 2022.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?a88d2158